import script from "./HorseGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./HorseGuide.vue?vue&type=script&setup=true&lang=js"

import "./HorseGuide.vue?vue&type=style&index=0&id=242b6ce1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242b6ce1"]])

export default __exports__